import * as Sentry from "@sentry/react";
import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";

export interface IntlErrorLike {
  code: string;
  message: string;
  descriptor?: { id?: string };
}

// Single sink for react-intl's onError across every IntlProvider (app-root and scoped): a Sentry
// breadcrumb for missing translations and a captured message for format errors. Scoped providers
// (e.g. DevelopIntlScope) route through here too, so a malformed ICU string still reaches Sentry
// instead of a bare console.error.
export function logIntlError(
  error: IntlErrorLike,
  { locale, component }: { locale: LanguagesIsoEnum; component: string },
): void {
  if (error.code === "MISSING_TRANSLATION") {
    console.warn(`[i18n] Missing translation "${error.descriptor?.id}" for locale ${locale}`);
    Sentry.addBreadcrumb({
      category: "i18n",
      message: `Missing translation key: ${error.descriptor?.id}`,
      level: "warning",
      data: { locale, messageId: error.descriptor?.id, component },
    });
  } else if (error.code === "FORMAT_ERROR") {
    console.error(`[i18n] Format error: ${error.message}`);
    Sentry.captureMessage(`i18n format error: ${error.message}`, {
      level: "error",
      tags: { component, errorCode: error.code },
      extra: { locale },
    });
  }
}
